import(/* webpackMode: "eager" */ "/vercel/path0/src/app/template.tsx");
